export default "__VITE_ASSET__DuFvayjR__"